import { PencilIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { User } from '../../../gql/graphql'
import { APP_ADD_SECTION_TO_USER } from '../../_constants/permissions'
import { useSchedule } from '../ScheduleContext'
import { useMyself } from '../UserContext'
import { SectionEditView } from './SectionEditView'

type PropTypes = {
  profile: User
}

export const SectionEdit = ({profile}: PropTypes) => {
  const [open, setOpen] = useState(false)
  const { canAccess } = useMyself() || {}
  const { season } = useSchedule() || {}

  if (canAccess && !canAccess(APP_ADD_SECTION_TO_USER)) {
    return null
  }

  return (
    <>
      <button
        className={'flex justify-center disabled:text-gray-400 focus:outline-0'}
        onClick={() => setOpen(true)}
      >
        <PencilIcon className={'w-4 h-4'} />
      </button>

      <SectionEditView
        open={open}
        onClose={() => setOpen(false)}
        season={season}
        profile={profile}
      />
    </>
  )
}
